module.exports = __webpack_public_path__ + "img/icon-control.90dfb8ef.png";